import { useState } from "react";
import { TableBody, TableCell, TableHead, TableRow } from "@material-ui/core"
import { dayMonthDateFormat } from '../../constants'
import moment from 'moment'
function EngOnOffWingList({ basicDetailData }) {
    const [lessMore, setLessMore] = useState({});
    const toggleLessMore = (lessMr) => {
        setLessMore({
            ...lessMore,
            [lessMr]: !lessMore[lessMr]
        });
    }
    const lessMoreFn = (name, lessMr) => {
        return <>
            {name && name?.length > 50 ? (
                <>
                    {lessMore[lessMr] ?
                        (<> {name} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
                        :
                        (<>{name.substring(0, 50)} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
                    }
                </>
            ) : name || '--'
            }
        </>
    }
    return (
        <>
            <TableHead className="table-head">
                <TableRow>
                    <TableCell className="font-b">Wing Status</TableCell>
                    {basicDetailData?.on_wing_status && <TableCell className="font-b"> On Wing MSN </TableCell>}
                    {basicDetailData?.on_wing_status && <TableCell className="font-b"> On Wing Owner </TableCell>}
                    {basicDetailData?.off_wing_status && <TableCell className="font-b"> Off wing Condition </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell className="font-b"> TSN of Engine Removal </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell className="font-b"> CSN of Engine Removal </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell className="font-b"> Date of Engine Removal </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell className="font-b"> Reason of Engine Removal </TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    {basicDetailData?.on_wing_status ? <TableCell> On Wing</TableCell> : <TableCell> Off Wing</TableCell>}
                    {basicDetailData?.on_wing_status && <TableCell >{basicDetailData?.on_wing_msn || '--'}</TableCell>}
                    {basicDetailData?.on_wing_status && <TableCell >{basicDetailData?.on_wing_lessor || '--'} </TableCell>}
                    {basicDetailData?.off_wing_status && <TableCell>{basicDetailData?.off_wing_status?.label || '--'} </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell>{basicDetailData?.off_wing_detail?.tsn_at_removal || '--'} </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell>{basicDetailData?.off_wing_detail?.csn_at_removal || '--'} </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell>{basicDetailData?.off_wing_detail?.date_of_removal ? moment(basicDetailData?.off_wing_detail?.date_of_removal).format(dayMonthDateFormat) : '--'} </TableCell>}
                    {basicDetailData?.off_wing_detail && <TableCell>{lessMoreFn(basicDetailData?.off_wing_detail?.reason_for_removal, 'reason_for_removal')} </TableCell>}
                </TableRow>
            </TableBody>
            <TableHead className="table-head">
                <TableRow>
                    {basicDetailData?.off_wing_detail && <TableCell className="font-b"> Preservation Performed </TableCell>}
                    {
                        basicDetailData?.off_wing_status?.value === 2 ? <>
                            <TableCell className="font-b"> Release Date of the Assembly </TableCell>
                            <TableCell className="font-b"> Shop Visit Report Provided </TableCell>
                            <TableCell className="font-b"> Type of Shop Visit </TableCell>
                            <TableCell className="font-b"> Expected Date of Shipment Back to Lessee </TableCell>
                            <TableCell className="font-b"> Facility Name </TableCell> </> :
                            basicDetailData?.off_wing_status?.value === 3 ? <>
                                <TableCell className="font-b"> Expected Release Date of the Assembly? </TableCell>
                                <TableCell className="font-b"> Induction Date of Assembly </TableCell>
                                <TableCell className="font-b"> Workscope Status </TableCell>
                                <TableCell className="font-b"> Facility Name </TableCell>
                                <TableCell className="font-b"> Facility Location </TableCell>
                            </> :
                                basicDetailData?.off_wing_status?.value === 4 ?
                                    <>
                                        <TableCell className="font-b"> Expected Date of Installation On Aircraft </TableCell>
                                        <TableCell className="font-b"> Shop Visit Performed </TableCell>
                                        <TableCell className="font-b"> Shop Visit Report Status </TableCell>
                                        <TableCell className="font-b"> Asset Location </TableCell>
                                    </> :
                                    basicDetailData?.off_wing_status?.value === 5 &&
                                    <>
                                        <TableCell className="font-b"> Shop Visit Requirement </TableCell>
                                        <TableCell className="font-b"> Expected Date of Shipment Shop </TableCell>
                                        <TableCell className="font-b"> Which Shop has Been Selected ? </TableCell>
                                        <TableCell className="font-b"> Asset Location </TableCell>
                                    </>
                    }

                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    {basicDetailData?.off_wing_detail && <TableCell>{basicDetailData?.off_wing_detail?.preservation_performed ? "YES" : "NO" || '--'} </TableCell>}
                    {
                        basicDetailData?.off_wing_status?.value === 2 ? <>
                            <TableCell>{basicDetailData?.off_wing_detail?.release_date_of_the_engine ? moment(basicDetailData?.off_wing_detail?.release_date_of_the_engine).format(dayMonthDateFormat) : '--'} </TableCell>
                            <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_report_provided ? "YES" : "NO" || '--'} </TableCell>
                            <TableCell>{basicDetailData?.off_wing_detail?.type_of_shop_visit?.label || '--'} </TableCell>
                            <TableCell>{basicDetailData?.off_wing_detail?.expected_date_of_shipment_back_to_lessee ? moment(basicDetailData?.off_wing_detail?.expected_date_of_shipment_back_to_lessee).format(dayMonthDateFormat) : '--'} </TableCell>
                            <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_name || '--'} </TableCell>
                        </> :
                            basicDetailData?.off_wing_status?.value === 3 ? <>
                                <TableCell>{basicDetailData?.off_wing_detail?.expected_release_date_of_the_engine ? moment(basicDetailData?.off_wing_detail?.expected_release_date_of_the_engine).format(dayMonthDateFormat) : '--'} </TableCell>
                                <TableCell>{basicDetailData?.off_wing_detail?.induction_date_of_engine ? moment(basicDetailData?.off_wing_detail?.induction_date_of_engine).format(dayMonthDateFormat) : '--'} </TableCell>
                                <TableCell>{basicDetailData?.off_wing_detail?.work_scope_status?.label || '--'} </TableCell>
                                <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_name || '--'} </TableCell>
                                <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_location || '--'} </TableCell>
                            </> :
                                basicDetailData?.off_wing_status?.value === 4 ?
                                    <>
                                        <TableCell>{basicDetailData?.off_wing_detail?.expected_date_of_installation_on_wing ? moment(basicDetailData?.off_wing_detail?.expected_date_of_installation_on_wing).format(dayMonthDateFormat) : '--'} </TableCell>
                                        <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_performed ? "YES" : "NO" || '--'} </TableCell>
                                        <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_report_status?.label || '--'} </TableCell>
                                        <TableCell>{basicDetailData?.off_wing_detail?.off_wing_location || '--'} </TableCell>

                                    </> :
                                    basicDetailData?.off_wing_status?.value === 5 &&
                                    <>
                                        <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_requirement?.label || '--'} </TableCell>
                                        <TableCell>{basicDetailData?.off_wing_detail?.expected_date_of_shipment_to_shop ? moment(basicDetailData?.off_wing_detail?.expected_date_of_shipment_to_shop).format(dayMonthDateFormat) : '--'} </TableCell>
                                        <TableCell>{basicDetailData?.off_wing_detail?.selected_shop || '--'} </TableCell>
                                        <TableCell>{basicDetailData?.off_wing_detail?.off_wing_location || '--'} </TableCell>
                                    </>
                    }

                </TableRow>
            </TableBody>
            <TableHead className="table-head">
                <TableRow> {basicDetailData?.off_wing_status?.value === 2 && <TableCell className="font-b"> Facility Location </TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow> {basicDetailData?.off_wing_status?.value === 2 && <TableCell>{basicDetailData?.off_wing_detail?.shop_visit_location || '--'} </TableCell>}
                </TableRow>
            </TableBody>
        </>
    )
}

export default EngOnOffWingList